import type { ChatConversation } from "@/lib/chatApi";

export function aurizEligibility(selected: ChatConversation | null): { ready: boolean; title: string } {
  if (!selected || selected.type !== "dm") {
    return { ready: false, title: "" };
  }
  return { ready: true, title: "Envoyer un Auriz" };
}
